module.exports = __webpack_public_path__ + "static/img/码上直播@4x.d9ca7a60.png";